/* Pegasus — cesta lateral contra el carrito real de Shopify */
(function () {
  var root = document.querySelector('[data-pg-drawer]');
  if (!root) return;
  var scrim = document.querySelector('[data-pg-scrim]');
  var lines = root.querySelector('[data-pg-lines]');
  var totalEl = root.querySelector('[data-pg-total]');
  var shipEl = root.querySelector('[data-pg-ship]');
  var barEl = root.querySelector('[data-pg-bar]');
  var costEl = root.querySelector('[data-pg-shipcost]');
  var codEl = root.querySelector('[data-pg-cod]');
  var checkout = root.querySelector('[data-pg-checkout]');
  var free = Number(root.dataset.pgFree || 3500);
  var rate = Number(root.dataset.pgRate || 495);

  function eur(c) { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); }

  function render(cart) {
    var n = cart.item_count;
    document.querySelectorAll('[data-pg-count]').forEach(function (b) { b.textContent = n; });

    if (!n) {
      lines.innerHTML = '<p class="pg-empty">Tu cesta está vacía.<br>Echa un vistazo al catálogo.</p>';
    } else {
      lines.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') + '" alt="">' : '';
        return '<div class="pg-line">' +
          '<a class="th" href="' + it.url + '">' + img + '</a>' +
          '<div><h3>' + it.product_title + '</h3>' +
          '<span class="pg-qty">' +
            '<button type="button" data-pg-qty="' + it.key + '" data-q="' + (it.quantity - 1) + '" aria-label="Quitar una unidad">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-pg-qty="' + it.key + '" data-q="' + (it.quantity + 1) + '" aria-label="Añadir una unidad">+</button>' +
          '</span>' +
          '<button type="button" class="pg-rm" data-pg-qty="' + it.key + '" data-q="0">Quitar</button>' +
          '</div>' +
          '<div class="lp">' + eur(it.final_line_price) + '</div></div>';
      }).join('');
    }

    var envio = (n === 0 || cart.total_price >= free) ? 0 : rate;
    totalEl.textContent = eur(cart.total_price);
    if (costEl) costEl.textContent = n === 0 ? '—' : (envio === 0 ? 'Gratis' : eur(envio));
    if (codEl) codEl.textContent = n === 0 ? '—' : eur(cart.total_price + envio);

    var left = free - cart.total_price;
    if (!n) {
      shipEl.innerHTML = 'Envío gratis a partir de ' + eur(free) + '.';
    } else if (left > 0) {
      shipEl.innerHTML = 'Te faltan <b>' + eur(left) + '</b> para el envío gratis.';
    } else {
      shipEl.innerHTML = '<b>Envío gratis conseguido.</b>';
    }
    barEl.style.width = Math.min(100, (cart.total_price / free) * 100) + '%';

    checkout.disabled = !n;
    checkout.style.opacity = n ? 1 : .45;
  }

  function load() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(render); }

  function open() {
    root.setAttribute('open', '');
    scrim.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    var c = root.querySelector('[data-pg-close]');
    if (c) c.focus();
  }
  function close() {
    root.removeAttribute('open');
    scrim.removeAttribute('open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pg-open-cart]')) { e.preventDefault(); load(); open(); }
    if (e.target.closest('[data-pg-close]') || e.target === scrim) close();

    var q = e.target.closest('[data-pg-qty]');
    if (q) {
      q.disabled = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: q.dataset.pgQty, quantity: Number(q.dataset.q) }) })
        .then(function (r) { return r.json(); }).then(render);
    }

    var nav = e.target.closest('[data-pg-nav-toggle]');
    if (nav) {
      var panel = document.querySelector('[data-pg-nav]');
      if (panel.hasAttribute('open')) { panel.removeAttribute('open'); document.body.style.overflow = ''; }
      else { panel.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (root.hasAttribute('open')) close();
    var panel = document.querySelector('[data-pg-nav][open]');
    if (panel) { panel.removeAttribute('open'); document.body.style.overflow = ''; }
  });

  document.addEventListener('cart:refresh', function () { load().then(open); });
  load();
})();
